import { updateDataRequest } from "../../../api/controller/BagFinderController";

// Re-export the bags data structure and select atoms so the update modal
// uses the same form definitions without duplication.
export {
    bagDataStructureState as dataStructureState,
    bagBagStatusState,
    bagForwardTypeState,
    bagArrivalFlightState,
    bagDepartureFlightState,
    bagDamageBagClaimState,
} from "../bags/state";

export const modalConfigDefault = { size: "lg", wizard: false };

export const formModes = {
    update: [{ name: 'Default Update', action: updateDataRequest }],
    view:   [{ name: 'Default View' }],
};
